module.exports = __webpack_public_path__ + "img/A10-20000044-011.df0a4c99.jpg";